import { FC } from 'react'

import { Avatar, AvatarColorProps, Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { PeopleChartGroupSidepanelBasicInfoFragment } from 'generated/resources/graphql'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type { EditTeamFormValues } from '../GroupSidepanel/forms'

type Props = {
  basicInfo: PeopleChartGroupSidepanelBasicInfoFragment
  color?: AvatarColorProps
  form: FormikProps<EditTeamFormValues>
  loading: boolean
}

const GroupDetailForm: FC<Props> = ({ basicInfo, color = 'grey', form, loading }) => {
  const name = form.values.name
  const description = form.values.description

  return (
    <Box gap="s16">
      <Box gap="s16" flexDirection="row" alignItems="center">
        <Avatar size="s64" label={basicInfo.name} color={color} url={basicInfo.avatar} />
      </Box>
      <TextField
        label={i18n.t('people_chart.group.title')}
        error={form.errors.name}
        value={name}
        onChange={(value: string) => form.setValues({ ...form.values, name: value })}
        loading={loading}
      />
      <TextArea
        label={i18n.t('people_chart.group.description')}
        value={description}
        error={form.errors.name}
        onChange={(value: string) => form.setValues({ ...form.values, description: value })}
        loading={loading}
      />
    </Box>
  )
}

export default GroupDetailForm
